import React, { useCallback, useEffect, useState } from 'react';
import { DragDropContext } from 'react-beautiful-dnd';

import Drop from '@/components/common/Dnd/Drop';

import FolderItems from './FolderItems';

export const SECTION_DROPPABLE_ID = 'section-dropzone';
export const ROOT_FILES_DROPPABLE_ID = 'root-folder-item-dropzone';
export const SECTION_FOLDER_ITEMS_DROPZONE_TYPE =
  'section-folder-items-dropzone';
export const FILE_FOLDER_ITEMS_DROPZONE_TYPE =
  'file-folder-items-dropzone';

const className = 'c-PortalContent-FolderItemsDropContext';

const FolderItemsDropContext = (props) => {
  const { sectionFolderItemsList, filesFolderItemsList, onDndDragEnd } =
    props;

  useEffect(() => {
    document.documentElement.style.scrollBehavior = 'auto';
    // clean up, remove scrollBehaviour when unmount
    return () => {
      document.documentElement.style.scrollBehavior = '';
    };
  }, []);

  // Using collapsedSectionsFolderItems to keep track of which sections are collapsed
  // Using collapsedSectionsFolderItems instead of expanded because by default everything is expanded
  const [collapsedSectionsFolderItems, setCollapsedSectionFolderItems] =
    useState({});

  const toggleSectionAccordion = useCallback((id) => {
    setCollapsedSectionFolderItems((prev) => {
      return {
        ...prev,
        [id]: !prev[id]
      };
    });
  }, []);

  return (
    <div className={className}>
      <DragDropContext onDragEnd={onDndDragEnd}>
        <div className="flex flex-col mb-[60px]">
          {/* Sections */}
          <div>
            <Drop
              id={SECTION_DROPPABLE_ID}
              type={SECTION_FOLDER_ITEMS_DROPZONE_TYPE}
              className="flex flex-col space-y-12 rounded-12">
              <FolderItems
                key="section-folder-items"
                folderItemsList={sectionFolderItemsList}
                collapsedSectionsFolderItems={collapsedSectionsFolderItems}
                toggleSectionAccordion={toggleSectionAccordion}
              />
            </Drop>
          </div>
          {/* Files */}
          <div>
            <Drop
              id={ROOT_FILES_DROPPABLE_ID}
              type={FILE_FOLDER_ITEMS_DROPZONE_TYPE}
              className="flex flex-col space-y-12 rounded-12">
              <FolderItems
                key="file-folder-items"
                folderItemsList={filesFolderItemsList}
              />
            </Drop>
          </div>
        </div>
      </DragDropContext>
    </div>
  );
};

export default React.memo(FolderItemsDropContext);
